import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { RoleGate } from '@/context/auth/role-gate';
import type { AuthUser } from '@/context/store/slices/authSlice';

import './nav-item.scss';

// Mirrors the Role type used internally by RoleGate.
type Role = AuthUser['role'];

type NavItemProps = {
  to: string;
  icon: ReactNode;
  label: string;
  roles?: Role[];
};

function NavItem({ to, icon, label, roles }: NavItemProps) {
  const link = (
    <Link
      to={to as never}
      title={label}
      className="nav-item"
      activeProps={{ className: 'nav-item is-active' }}
      activeOptions={{ exact: false }}
    >
      {icon}
    </Link>
  );

  if (!roles || roles.length === 0) return link;
  return <RoleGate roles={roles}>{link}</RoleGate>;
}

export { NavItem };
